<clx-form
    #form 
    [create]="create.bind(this)" 
    [update]="update.bind(this)"
    (deleted)="delete()"
    [data]="data"
    [globalValidationMessages]="true"
    (keypress)="preventEnter($event)"
>
    <!-- <clx-message 
        type="success" 
        i18n="@@third-party-app.save.success"
        test-id="third-party-app.message.success"
    >The App was successfully saved.</clx-message> //-->

    <clx-message 
        type="error"
        i18n="@@third-party-app.save.error"
        test-id="third-party-app.message.error"
    >Some Error occured!</clx-message>

    <clx-row type="buttons">
        <span *ngIf="mode === 'update' && isPrimaryTenant" class="message warning inline">
            <span class="fa fa-info-circle"></span>
            <span i18n="@@third-party-app.message.savedelay">NOTE: Changes may take up to 1 hour to become active.</span>
        </span>
        <clx-button *ngIf="mode === 'create' || isPrimaryTenant" type="save" test-id="third-party-app.button.save" i18n="@@third-party-app.save">Save</clx-button>
        <clx-button *ngIf="mode === 'update' && isPrimaryTenant" type="delete" test-id="third-party-app.button.delete" i18n="@@third-party-app.delete">Delete</clx-button>
        <clx-button *ngIf="mode === 'update' && !isPrimaryTenant" type="delete" test-id="third-party-app.button.unregister" i18n="@@third-party-app.unregister">Unregister</clx-button>
    </clx-row>

    <clx-row *ngIf="mode==='update'">
        <clx-label i18n="@@third-party-app.id">App Id:</clx-label>
        <clx-input test-id="third-party-app.id" name="clientId" disabled></clx-input>
    </clx-row>
    <clx-row>
        <clx-label i18n="@@third-party-app.name">Name</clx-label>
        <clx-input test-id="third-party-app.name" name="name" [disabled]="isPrimaryTenant ? undefined : true">
            <clx-validation type="required"></clx-validation>
        </clx-input>
    </clx-row>
    <!-- <clx-row>
        <clx-label i18n="@@third-party-app.is-enabled">Enabled</clx-label>
        <clx-checkbox test-id="third-party-app.isenabled" name="isEnabled" [disabled]="isPrimaryTenant ? undefined : true">
            <clx-value key="true"></clx-value>
            <clx-value key="false"></clx-value>
        </clx-checkbox>
    </clx-row> -->
    <clx-row>
        <clx-label i18n="@@third-party-app.client-uri">Client Uri</clx-label>
        <clx-input test-id="third-party-app.clienturi" name="clientUri" [disabled]="isPrimaryTenant ? undefined : true">
            <clx-validation type="required"></clx-validation>
            <clx-validation type="url"></clx-validation>
            <clx-validation type="urlprotocol" [allowedProtocols]="['https']"></clx-validation>
        </clx-input>
    </clx-row>
    <!-- <clx-row>
        <clx-label i18n="@@third-party-app.logo-uri">Logo Uri</clx-label>
        <clx-input test-id="third-party-app.logouri" name="logoUri" [disabled]="isPrimaryTenant ? undefined : true">
            <clx-validation type="url"></clx-validation>
        </clx-input>
    </clx-row> -->
    <clx-row has="no-margins">
        <clx-label i18n="@@third-party-app.redirect-uris">redirect Uri</clx-label>
        <clx-repeater #repeater name="redirectUris">
            <ng-template let-data="row" let-entries="data">
                <clx-row has="full-size-columns">
                    <clx-item [attr.has]="entries.length > 1 ? 'input-button-layout' : null">
                        <clx-input test-id="third-party-app.redirecturi" name="uri" [disabled]="isPrimaryTenant ? undefined : true">
                            <clx-validation type="required"></clx-validation>
                            <clx-validation type="url"></clx-validation>
                            <clx-validation type="urlprotocol" [allowedProtocols]="['https']"></clx-validation>
                        </clx-input>
                        <button
                            title="Remove entry"
                            i18n-title="@@third-party-app.redirect-uris.button.remove"
                            class="default small-icon icon fa fa-minus-square no-background"
                            test-id="third-party-app.redirect-uris.button.remove"
                            (click)="repeater.deleteEntry(data)"
                            *ngIf="entries.length > 1 && isPrimaryTenant"
                        ></button>
                    </clx-item>
                </clx-row>
            </ng-template>
        </clx-repeater>
    </clx-row>
    <clx-row *ngIf="isPrimaryTenant" type="buttons" has="no-margins">
        <a test-id="third-party-app.link.redirecturi.add" (click)="repeater.addEntry()" class="default-link" i18n="@@third-party-app.redirect-uris.button.add">Add redirect Url</a>
    </clx-row>
    <!-- <clx-row has="no-margins">
        <clx-label i18n="@@third-party-app.post-logout-redirect-uris">Post logout redirect Uris</clx-label>
        <clx-repeater #redirectUrisRepeater name="postLogoutRedirectUris">
            <ng-template let-data="row" let-entries="data">
                <clx-row has="full-size-columns">
                    <clx-item [attr.has]="entries.length > 1 ? 'input-button-layout' : null">
                        <clx-input test-id="third-party-app.postlogoutredirecturi" name="uri" [disabled]="isPrimaryTenant ? undefined : true">
                            <clx-validation type="required"></clx-validation>
                            <clx-validation type="url"></clx-validation>
                        </clx-input>
                        <button
                            title="remove entry"
                            i18n-title="@@third-party-app.post-logout-redirect-uris.button.add"
                            class="default small-icon icon fa fa-minus-square no-background"
                            test-id="third-party-app.post-logout-redirect-uris.button.add"
                            (click)="redirectUrisRepeater.deleteEntry(data)"
                            *ngIf="entries.length > 1 && isPrimaryTenant"
                        ></button>
                    </clx-item>
                </clx-row>
            </ng-template>
        </clx-repeater>
    </clx-row>
    <clx-row *ngIf="isPrimaryTenant" type="buttons" has="no-margins">
        <a test-id="third-party-app.link.postlogoutredirecturi.add" (click)="redirectUrisRepeater.addEntry()" class="default-link" i18n="@@third-party-app.post-logout-redirect-uris.button.remove">Add post logout redirect Uri</a>
    </clx-row> -->

    <clx-row *ngIf="mode==='update' && isPrimaryTenant">
        <clx-label i18n="@@third-party-app.primary">Primary Secret</clx-label>
        <clx-item has="input-button-layout">
            <clx-input type="password" test-id="third-party-app.primarysecret" name="primarySecret" disabled></clx-input>
            <button
                title="remove entry"
                class="default small-icon icon fa fa-refresh no-background"
                title="renew secret"
                i18n-title="@@third-party-app.primary-secret.refresh.title"
                test-id="third-party-app.primary-secret.refresh"
                (click)="updatePrimarySecret()"
                [ngClass]="{'fa-spin': isUpdatingPrimarySecret}"
                [disabled]="isUpdatingPrimarySecret ? 'disabled' : null"
            ></button>
        </clx-item>
    </clx-row>

    <clx-row *ngIf="mode==='update' && isPrimaryTenant">
        <clx-label i18n="@@third-party-app.secondary-secret">Secondary Secret</clx-label>
        <clx-item has="input-button-layout">
            <clx-input type="password" test-id="third-party-app.secondarysecret" name="secondarySecret" disabled></clx-input>
            <button
                title="remove entry"
                class="default small-icon icon fa fa-refresh no-background"
                title="renew secret"
                i18n-title="@@third-party-app.secondary-secret.refresh.title"
                test-id="third-party-app.secondary-secret.refresh"
                (click)="updateSecondarySecret()"
                [ngClass]="{'fa-spin': isUpdatingSecondarySecret}"
                [disabled]="isUpdatingSecondarySecret ? 'disabled' : null"
            ></button>
        </clx-item>
    </clx-row>

    <clx-row *ngIf="mode==='update'">
        <clx-label i18n="@@third-party-app.authority">Authority</clx-label>
        <clx-input test-id="third-party-app.authority" name="authority" disabled></clx-input>
    </clx-row>

    <clx-row *ngIf="mode==='update'">
        <clx-label i18n="@@third-party-app.metadataAddress">Metadata address</clx-label>
        <clx-input test-id="third-party-app.metadataAddress" name="metadataAddress" disabled></clx-input>
    </clx-row>
</clx-form>